import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const DynamicCloseButton = ({ closeToast, type }) => {
  // Use white for success, error, info, warning which have colored backgrounds
  // Use black for default/light themes
  const color = (type === 'success' || type === 'error' || type === 'info' || type === 'warning') 
    ? "#FFFFFF" 
    : "#000000";

  return (
    <button 
      onClick={(e) => { e.stopPropagation(); closeToast(); }}
      type="button"
      style={{ 
        background: "none",
        border: "none",
        color: color, 
        fontSize: "24px",
        fontWeight: "300",
        padding: "0 15px",
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        lineHeight: "1",
        opacity: "0.9",
        outline: "none"
      }}
      onMouseOver={(e) => e.target.style.opacity = "1"}
      onMouseOut={(e) => e.target.style.opacity = "0.9"}
    >
      ×
    </button>
  );
};

toast.configure({
  position: "top-center",
  autoClose: 5000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
  theme: "light",
  closeButton: DynamicCloseButton,
  style: {
    width: "min(520px, 88vw)",
    minWidth: "200px",
    maxWidth: "90vw",
    height: "auto",
    minHeight: "72px",
    borderRadius: "8px",
    fontSize: "14px",
    lineHeight: "20px",
    padding: "18px 18px",
    margin: "10px auto",
    boxSizing: "border-box",
    zIndex: 1000000,
  },
});

const lastToasts = new Map();

/**
 * Custom toast wrapper that:
 * 1. Prevents duplicate error messages within a 4s window.
 * 2. Uses setTimeout(0) to ensure toast side effects happen outside the Redux reducer cycle.
 *    This prevents "You may not call store.getState() while the reducer is executing" errors.
 */
const debouncedToast = {
  ...toast,
  error: (message, options = {}) => {
    const now = Date.now();
    const lastTime = lastToasts.get(message) || 0;
    if (now - lastTime > 4000) {
      lastToasts.set(message, now);
      setTimeout(() => {
        toast.error(message, { ...options, type: 'error' });
      }, 0);
    }
    return null;
  },
  success: (message, options = {}) => {
    setTimeout(() => {
      toast.success(message, { ...options, type: 'success' });
    }, 0);
    return null;
  },
  info: (message, options = {}) => {
    setTimeout(() => {
      toast.info(message, { ...options, type: 'info' });
    }, 0);
    return null;
  },
  warning: (message, options = {}) => {
    setTimeout(() => {
      toast.warning(message, { ...options, type: 'warning' });
    }, 0);
    return null;
  }
};

export default debouncedToast;
